var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import * as zIndex from './zIndex.js';
let ExEditorToolbarDropdownElement = class ExEditorToolbarDropdownElement extends LitElement {
    render() {
        return html `<slot></slot>`;
    }
};
ExEditorToolbarDropdownElement.styles = [
    css `
      :host {
        box-sizing: border-box;
        z-index: ${zIndex.dropdown};
        display: flex;
        flex-direction: column;
        position: absolute;
        width: fit-content;
        min-height: 32px;
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 0 10px 0 rgb(0 0 0 / 6%);
      }

      :host([toward='vertical']) {
        top: 0;
        left: 100%;
        margin-left: 2px;
      }
    `,
];
ExEditorToolbarDropdownElement = __decorate([
    customElement('exeditor-toolbar-dropdown')
], ExEditorToolbarDropdownElement);
export { ExEditorToolbarDropdownElement };
//# sourceMappingURL=toolbar-dropdown.js.map